module.exports = __webpack_public_path__ + "static/animaldeermain-9fe266d1067801a071034d2885442695.png";